import { InteractionType } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';

import React, { useEffect } from 'react';

import { UnidentifiedFallback } from '@/components';
import { loginRequest } from '@/lib/react-msal/authConfig';

interface IWithAuthenticatedTemplateManagerProps {
  children: React.ReactNode;
}

const AuthenticatedTemplateManager: React.FunctionComponent<IWithAuthenticatedTemplateManagerProps> = ({
  children,
}) => {
  const { login, error } = useMsalAuthentication(InteractionType.Silent, loginRequest);

  useEffect(() => {
    if (error) {
      login(InteractionType.Redirect, loginRequest);
      // instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    }
  }, [error, login]);
  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnidentifiedFallback />
      </UnauthenticatedTemplate>
    </>
  );
};

export default AuthenticatedTemplateManager;
